import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404Component } from './authentication/page404/page404.component';
import { AuthGuard } from './core/guard/auth.guard';
import { Role } from './core/models/role';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/authentication/signin', pathMatch: 'full' },
      {
        path: 'admin',
        canActivate: [AuthGuard],
        data: {
          role: Role.Admin,
        },
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'shop',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./shop/shop.module').then(
            (m) => m.ShopModule
          ),
      },
      {
        path: 'products',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./products/products.module').then(
            (m) => m.ProductsModule
          ),
      },
      {
        path: 'cart',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./product-cart/product-cart.module').then(
            (m) => m.ProductCartModule
          ),
      },
      {
        path: 'support',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./support/support.module').then(
            (m) => m.SupportModule
          ),
      },
      {
        path: 'orders',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./orders/orders.module').then(
            (m) => m.OrdersModule
          ),
      },
      {
        path: 'maleman',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./maleman/maleman.module').then(
            (m) => m.MalemanModule
          ),
      },
      // {
      //   path: 'maleman-kit',
      //   canActivate: [AuthGuard],
      //   loadChildren: () =>
      //     import('./production-utilities/production-utilities.module').then(
      //       (m) => m.ProductionUtilitiesModule
      //     ),
      // },
      // {
      //   path: 'facility-management',
      //   canActivate: [AuthGuard],
      //   loadChildren: () =>
      //     import('./facility-management/facility-management.module').then(
      //       (m) => m.FacilityManagementModule
      //     ),
      // },
      {
        path: 'MaleMan-settings',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./male-man-settings/male-man-settings.module').then(
            (m) => m.MaleManSettingsModule
          ),
      },
    ],
  },
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'forgot-password',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },

  { path: '**', component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
